export function getCacheKey(messageType: string, message: any): string {
   let retval;

   switch (messageType) {
      case 'BucketSummaryDto': {
         retval = `bucksum:${message.bucketType}-${message.terminalId}-${message.portfolioId}-${message.comboId}-${message.comboGroupId}`;
         break;
      }
      case 'StrategyPriceDto': {
         retval = message.strategyCode;
         break;
      }
      case 'QuoteDto': {
         retval = `quote:${message.ticker}-${message.tag}`;
         break;
      }
      case 'OrderDto': {
         retval = message.orderId;
         break;
      }
      case 'PositionDto': {
         retval = message.positionId;
         break;
      }
      case 'TerminalTotalPositionDto': {
         retval = message.terminalId;
         break;
      }
      case 'StrategyStatusDto':
      case 'StrategySessionActivityMessageDto':
      case 'StrategyStateDto':
      case 'StrategyTradePnLDto':
      case 'StrategyOpenPositionSnapshotDto': {
         retval = message.strategyId;
         break;
      }
      case 'AggregatedPositionDto': {
         retval = `aggpos:${message.terminalId}-${message.accountId}-${message.tradingInstrumentCode}=${message.positionClass}`;
         break;
      }
      case 'PnLSnapshotDto': {
         retval = message.subscriptionId;
         break;
      }
      // CR-20260508-001 iter 29 — ServerTimeMessageDto has no per-row
      // identity; constant key forces single-slot last-wins behavior.
      case 'ServerTimeMessageDto': {
         retval = 'singleton';
         break;
      }
      // CR-20260508-001 iter 34 — added to throttler to stop hiddenOther
      // accumulation during long hidden-tab windows (see
      // should-throttle-message comment for full rationale).
      case 'VerticalSkewChangedDto': {
         retval = `vskew:${message.underlying}-${message.expiration}`;
         break;
      }
      case 'SkewSentimentChangedDto': {
         retval = 'singleton';
         break;
      }
      // Horizontal Skew — one payload per (underlying, basis) carries the whole per-expiration
      // IV set, so keying by (underlying, basis) is collision-safe: a SPX tray on 30/90 and a
      // SPX OPG on 7/21 share the SAME slot/payload and each divides its own legs client-side.
      case 'HorizontalSkewChangedDto': {
         retval = `hskew:${message.underlying}:${message.basis}`;
         break;
      }
      case 'QuoteLimitDto': {
         retval = 'singleton';
         break;
      }
      // 2026-06-10 — latest-wins per position, like PositionDto. Storage is
      // namespaced per messageType, so the raw GUID cannot collide with
      // PositionDto keys. Matches the backend CacheKey identity (PositionId;
      // Topic omitted — a position belongs to exactly one terminal).
      case 'CollarsPositionChangedDto': {
         retval = message.positionId;
         break;
      }
      // CR-20260922-001 — one summary per user (backend CacheKey = UserId).
      case 'ActionBoardChangedDto': {
         retval = message.userId;
         break;
      }
      default: {
         throw new Error(`Message of type ${messageType} is does not support 'fresh-only' cache strategy`);
      }
   }

   return retval;
}
